import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/fontawesome-common-types';

export type TShopPillColor = 'success' | 'warn' | 'default' | 'error' | 'disabled';

@Component({
  selector: 'x-shop-pill',
  standalone: true,
  imports: [FaIconComponent, NgIf],
  templateUrl: './shop-pill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-shop-pill' },
})
export class ShopPillComponent {
  @Input() iconName: IconName;

  @HostBinding('class')
  @Input()
  color: TShopPillColor = 'default';
}
